<template>
  <div class="home">
    <template v-if="pageLayoutData">

      <!--
      <div class="videoHome">
        <video autoplay muted loop id="videoBgHero" class="videoHomeBg">
          <source src="img/video/cancun1.mp4" type="video/mp4">
        </video>
      </div>-->
      <!-- important !!! 
        /* override the slider motion in the bottom css section (fade-left-leave-to)  */ -->
      <slider
        :class="[`el-size--${elementSizes[0]}`]"
        :observe-resize="0"
        v-if="hpSlider"
        v-bind="hpSlider"
      ></slider>
      

      <div class="mis-promo container text-center rel">
        <div>
          <h2
            ref="title"
            class="text-center hp-title"
            :class="[
              animateLogo || dirtyHome ? 'logo-in' : '',
              logoMove || dirtyHome ? 'logo-move' : '',
              logoReady || dirtyHome ? 'logo-ready' : '',
              animateLetters || dirtyHome ? 'next' : ''
            ]"
          >
            <logo
              class="with-slogan"
              animate
              @animation-end="logoTransitionEnd"
            />
            <span
              :class="[
                'slogan-box',
                'font-rg',
                'pl-s',
                'ml-s',
                animateLetters || dirtyHome ? 'animate' : ''
              ]"
              @transitionend="sloganTransitionEnd"
              id="logo-slogan"
              >MAKE IT SIMPLE</span
            >
          </h2>
          <h3
            :class="[
              'logo-extra',
              sloganReady || dirtyHome ? 'show' : '',
              'text-center',
              'text-gray-6'
            ]"
            v-text="localize('hp_our_mission')"
          ></h3>
        </div>
      </div>


      
      <hp-boxes
        :class="[`el-size--${elementSizes[1]}`]"
        :observe-resize="1"
        v-if="hpBoxes"
        v-bind="hpBoxes"
      ></hp-boxes>
    </template>
    <preloader v-else></preloader>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
// @ is an alias to /src
export default {
  name: "home",
  data() {
    return {
      slider: null,
      boxes: null,
      code: "",
      logoReady: false,
      logoMove: false,
      animateLogo: false,
      sloganReady: false,
      animateLetters: false,
      ro: null,
      elementSizes: [],
      resizeTrig: -1,
      observed: null
    };
  },
  head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function() {
      //alert("this.pageTitle="+this.pageTitle);
      return {        
        inner: this.pageTitle
      };
    },
    meta: function() {
      return [
        { name: "description",  content: this.pageDescription,  id: "desc" },
        { name: "keywords",     content: this.pageKeywords,     id: "key" }
      ];
    },
  },
  watch: {
    pageLayoutData() {
      // console.log("PAGE DATA IS HERE: ", this.pageLayoutData);
      this.setPageReady(true);
      this.updateMeta();
    },
    locale: {
      deep: true,
      handler() {
        // console.log("HOMEPAGE LOCALE CHANGED >> ", this.locale);
        this.initRouteByPath(`Home/${this.$route.params.locale || "global"}`);
      }
    },
    logoReady() {
      /*
        Logo finished intro animating
      */
      this.$nextTick(function() {
        let slogan = document.getElementById("logo-slogan");
        slogan.innerHTML = slogan.textContent.replace(
          /\S/g,
          "<span class='scatter letter'>$&</span>"
        );
        setTimeout(
          function() {
            this.animateLetters = true;
          }.bind(this),
          0
        );
      });
    }
  },
  created() {
    this.setPageReady(false);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler, false);
  },
  async mounted() {
    // console.log("homepage mounted...", this.$defaultLang);

    this.initRouteByPath(`Home/${this.$route.params.locale || "global"}`);
    window.addEventListener("resize", this.resizeHandler, false);
    this.animateLogo = false;

    //Force the header title to update
    this.updateMeta();


    setTimeout(
      function() {
        this.animateLogo = true;
        // setTimeout(
        //   function() {
        //       this.logoMove = true;
        //   }.bind(this),
        //   3000
        // );
        this.$nextTick(function() {
          this.initResizeElements();
        });
      }.bind(this),
      1600
    );
  },
  methods: {
    ...mapActions(["initRouteByPath", "setPageReady", "dirtifyHome"]),
    updateMeta()
    {
      //Force the header title to update
      const titleEl = document.querySelector('head title');
      titleEl.textContent = this.pageTitle;
      document.querySelector('meta[name="description"]').setAttribute("content", this.pageDescription);
      document.querySelector('meta[name="keywords"]').setAttribute("content", this.pageKeywords);
    },
    logoTransitionEnd(e) {
      // console.log("transition ended... ", e);
      if (e.propertyName === "fill") {
        this.logoMove = true;
      } else if (e.propertyName === "left") {
        this.logoReady = true;
      }
    },
    sloganTransitionEnd: _.debounce(
      function() {
        // console.log("Slogan transition ended...");
        setTimeout(
          function() {
            this.sloganReady = true;
            this.dirtifyHome(true);
          }.bind(this),
          300
        );
      },
      600,
      { leading: true }
    ),
    resizeHandler: _.debounce(function() {
      let vm = this;
      if (!this.observed || !this.observed.length) {
        this.observed = document.querySelectorAll("[observe-resize]");
        this.elementSizes.length = this.observed.length;
      }
      // console.log("resize handler", this.observed);
      this.observed.forEach(function(el, index) {
        vm.elementResizeHandler(el, index);
      });
      // this.triggerResize();
    }, 300),
    initResizeElements() {
      this.observed = document.querySelectorAll("[observe-resize]");
      this.elementSizes.length = this.observed.length;
      this.resizeHandler();
    },
    elementResizeHandler(el) {
      if (el) {
        let index = index || el.getAttribute("observe-resize"),
          width = el.offsetWidth;
        if (width > 1200) {
          this.$set(this.elementSizes, index, "large");
        } else if (width > 815) {
          this.$set(this.elementSizes, index, "medium");
        } else {
          this.$set(this.elementSizes, index, "small");
        }
      }
    }
  },
  computed: {
    ...mapState(["pageLayoutData", "locale", "dirtyHome"]),
    pageTitle() {
      return this.pageLayoutData &&
        this.pageLayoutData.meta &&
        this.pageLayoutData.meta.page_title
        ? this.pageLayoutData.meta.page_title
        : "MIS - Dental Implants Technology";
    },
    pageDescription() {
      return this.pageLayoutData &&
        this.pageLayoutData.meta &&
        this.pageLayoutData.meta.meta_description
        ? this.pageLayoutData.meta.meta_description
        : "MIS - Dental Implants Technology";
    },
    pageKeywords() {
      return this.pageLayoutData &&
        this.pageLayoutData.meta &&
        this.pageLayoutData.meta.meta_keywords
        ? this.pageLayoutData.meta.meta_keywords
        : "MIS, dental implants, c1, v3";
    },    
    hpSlider() {
      let layout = this.pageLayoutData;
      console.log("layout > ", layout);
      if (layout) {
        return layout.children.find(item => item.type === "slider");
      }
      return null;
    },
    hpBoxes() {
      let layout = this.pageLayoutData;
      if (layout) {
        return layout.children.find(item => item.type === "hp-boxes");
      }
      return null;
    }
  }
};
</script>
<style lang="stylus" scoped>
.fade-from-top
  &-enter-active
  &-leave-active
    transition opacity 2s ease-out, transform 2s ease-out-cubic
  &-enter
  &-leave-to
    transform translateY(-50%) !important
  &-enter-to
  &-leave
    opacity 1 !important
    transform translateY(0) !important
.home
  position relative
  top 33px
  min-height 120vh
  .mis-promo
    // padding 60px 0
    // +below(768px)
    padding 44px 0
    +below(415px)
      _flex(row, wrap, center, center)
      padding 30px 0
  h2
    height 100%
    min-height 70px
    min-width 34vw
    position relative
    _flex(row, nowrap, baseline, center, true)
    +below(1100px)
      _flex(row, nowrap, flex-bottom, center, true)
      min-height auto
    .slogan-box
      color blue_primary
      border-left 1px solid blue_primary
      background #fff
      font-size responsive 27px 52px
      font-weight 500
      opacity 0
      overflow hidden
      & >>> .letter
        opacity 0
        display inline-block
        transform translateY(100%)
        position relative
        font-weight 300 !important
    &.logo-move
      .mis-logo
        left 0
        transform translateX(0)
    &.logo-ready
      .slogan-box.animate
        opacity 1
        & >>> .letter
          opacity 1
          transform translateY(0)
    &.next
      .mis-logo
        position static
        +below(1100px)
          height auto
        +below(415px)
          height 27px
  h3
    font-size responsive 14px 28px
    color gray_8
    &.logo-extra
      opacity 0
      transform translateY(-50%)
      transition opacity 0.4s ease-out, transform 0.4s ease-out
      &.show
        opacity 1
        transform translateY(0)
</style>

<style>
  .videoHome
  {
    width: 100vw;
    height: 70vh;
    overflow: hidden;
  }
  .videoHomeBg
  {
      min-width: 100%;
      min-height: 100%;
  }
  /* override the slider motion */
  .fade-left-leave-to
  {
    transform:translateX(0px) !important;
  }
  .fade-left-enter,
  .fade-right-leave-to
  {
    transform:translateX(0px) !important;
  }
</style>

